import React from 'react';
import styled from 'styled-components';

interface PerPageSelectorProps {
    value: string;
    onChange: (perPage: string) => void;
}

const perPageOptions = ['30', '50', '100', '500'];

const PerPageSelector: React.FC<PerPageSelectorProps> = ({ value, onChange }) => {
    return (
        <Wrapper>
            <Label>Show</Label>
            <Select
                data-testid="per-page-selector"
                value={value || '30'}
                onChange={e => onChange(e.target.value)}
            >
                {perPageOptions.map(option => (
                    <option key={option} value={option}>
                        {option}
                    </option>
                ))}
            </Select>
            <Label>rows</Label>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

const Label = styled.span`
    font-size: ${props => props.theme.text.size.small};
    color: ${props => props.theme.colors.text.secondary};
`;

const Select = styled.select`
    padding: 0.3rem 0.5rem;
    border-radius: 0.4rem;
    border: 0.1rem solid ${props => props.theme.colors.border};
    background: ${props => props.theme.colors.light};
    color: ${props => props.theme.colors.text.primary};
    font-size: ${props => props.theme.text.size.small};
    font-family: ${props => props.theme.text.font.regular};
    cursor: pointer;
    outline: none;

    &:focus {
        border-color: ${props => props.theme.colors.primary};
    }
`;

export default PerPageSelector;
